type Lang = 'tr' | 'en';
type Localized<T> = Record<Lang, T>;

export const SHALTERON_S_USE_CASES: Array<{
  image: string;
  title: Localized<string>;
  description: Localized<string>;
}> = [
  {
    image: '/shalteron_ka1.png',
    title: { tr: 'Bahçe ve Tarımsal Sulama Sistemleri', en: 'Garden & Agricultural Irrigation' },
    description: {
      tr: 'Sulama motorları, vanalar ve pompalar uzaktan açılıp kapatılabilir. Sulama panosundan gelen çalışıyor / duruyor bilgileri dijital girişler üzerinden izlenir ve kullanıcıya anında bildirim gönderilir. Aynı zamanda saha ortamındaki sıcaklık ve nem değerleri izlenerek sulama koşulları ve çevresel durum hakkında ek bilgi elde edilir.',
      en: 'Irrigation motors, valves and pumps can be switched remotely. Run/stop signals from the irrigation panel are monitored via digital inputs with instant user notifications. Field temperature and humidity are also tracked for better insight into irrigation conditions and the environment.'
    }
  },
  {
    image: '/shalteron_ka2.png',
    title: { tr: 'Sera Uygulamaları', en: 'Greenhouse Applications' },
    description: {
      tr: 'Fan, havalandırma, perde, sisleme ve ısıtma sistemleri mobil uygulama üzerinden tek dokunuşla uzaktan kontrol edilir. Harici pano, termostat veya zaman saatinden gelen çalışma / durma bilgileri dijital girişler üzerinden izlenir ve her değişimde anlık bildirim alınır. SHALTERON S, sera içindeki sıcaklık ve nem değerlerini sürekli izleyerek kullanıcılara sera ortamı hakkında gerçek zamanlı ve güvenilir bilgi sunar.',
      en: 'Fans, ventilation, curtains, misting and heating are controlled remotely from the mobile app. Signals from external panels, thermostats or timers are monitored on digital inputs with a notification on every change. SHALTERON S continuously tracks greenhouse temperature and humidity for reliable, real-time climate insight.'
    }
  },
  {
    image: '/shalteron_ka3.png',
    title: { tr: 'Jeneratör ve Enerji Yönetimi', en: 'Generator & Energy Management' },
    description: {
      tr: 'Jeneratör çalıştırma, durdurma veya reset işlemleri mobil uygulama üzerinden röle çıkışları ile kontrol edilebilir. Elektrik kesildiğinde veya jeneratör devreye girdiğinde anlık bildirim alınır. Jeneratör odasındaki sıcaklık ve nem değerleri izlenerek riskli ortam koşulları erkenden fark edilebilir.',
      en: 'Start, stop or reset the generator via relay outputs from the mobile app. Get instant alerts on mains failure or when the generator takes load. Monitor temperature and humidity in the generator room to spot risky conditions early.'
    }
  },
  {
    image: '/shalteron_ka4.png',
    title: { tr: 'Endüstriyel Ekipman Kontrolü', en: 'Industrial Equipment Control' },
    description: {
      tr: 'Makine, pompa, kompresör ve yardımcı ekipmanlar mobil uygulama üzerinden uzaktan yönetilir. Makineden gelen çalışma veya arıza kontakları izlenirken, pano ve ekipman ortamındaki sıcaklık ve nem değerleri takip edilerek güvenli çalışma koşulları desteklenir.',
      en: 'Machines, pumps, compressors and auxiliary equipment are managed remotely. Run/fault contacts are monitored while temperature and humidity around panels and equipment help support safe operating conditions.'
    }
  },
  {
    image: '/shalteron_ka5.png',
    title: { tr: 'Motor ve Pompa Kontrol Sistemleri', en: 'Motor & Pump Control' },
    description: {
      tr: 'AC/DC motorlar kontaktör üzerinden güvenli şekilde kontrol edilir. Motorun çalıştı / durdu bilgisi dijital girişler aracılığıyla takip edilir ve durum değişimlerinde anlık bildirim alınır. Motor ve pompa ekipmanlarının bulunduğu alanlardaki ortam koşulları uzaktan izlenebilir.',
      en: 'AC/DC motors are switched safely through contactors. Run/stop state is tracked on digital inputs with notifications on change. Ambient conditions where motors and pumps are installed can be monitored remotely.'
    }
  },
  {
    image: '/shalteron_ka4.png',
    title: { tr: 'Aydınlatma Kontrolü', en: 'Lighting Control' },
    description: {
      tr: 'Depo, fabrika, sera ve açık alan aydınlatmaları uzaktan kontrol edilir. Kullanım saatleri ve aydınlatma durumları izlenerek gereksiz enerji tüketimi azaltılır ve enerji verimliliği sağlanır.',
      en: 'Warehouse, factory, greenhouse and outdoor lighting is controlled remotely. Usage hours and on/off state are tracked to cut waste and improve energy efficiency.'
    }
  },
  {
    image: '/shalteron_ka3.png',
    title: { tr: 'Uzaktan Tesis ve Saha Yönetimi', en: 'Remote Site & Field Management' },
    description: {
      tr: 'Teknik odalar, pompa istasyonları ve saha ekipmanları internet altyapısına gerek kalmadan mobil uygulama üzerinden yönetilir. Kuru kontak değişimleriyle birlikte sıcaklık ve nem verileri anlık olarak izlenir ve raporlanır.',
      en: 'Technical rooms, pump stations and field equipment are managed via the mobile app without relying on local internet infrastructure. Dry-contact events are tracked together with live temperature and humidity for reporting.'
    }
  },
  {
    image: '/shalteron_ka5.png',
    title: { tr: 'Elektrikli Cihaz Uzaktan Aç / Kapat', en: 'Remote On/Off for Electrical Loads' },
    description: {
      tr: 'Isıtıcı, fan, kapı, bariyer, valf ve benzeri elektrikli cihazlar mobil uygulama üzerinden kontrol edilir. Yetkilendirme ve bildirim özellikleri sayesinde güvenli ve kontrollü kullanım sağlanırken, cihazların bulunduğu ortam koşulları da takip edilir.',
      en: 'Heaters, fans, doors, barriers, valves and similar loads are controlled from the app. Authorization and notifications support safe use while ambient conditions at the device location stay visible.'
    }
  },
  {
    image: '/shalteron_ka6.png',
    title: { tr: 'Alarm ve Güvenlik Sistemleri', en: 'Alarm & Security Systems' },
    description: {
      tr: 'Alarm panelleri, acil durum butonları ve güvenlik sistemleri SHALTERON S ile entegre çalışır. Bir alarm oluştuğunda mobil uygulamaya anında bildirim gider; gerekirse uzaktan müdahale edilebilir. Ortam sıcaklığı ve nemindeki olağandışı değişimler de kullanıcıya bildirilir.',
      en: 'Alarm panels, emergency buttons and security systems work with SHALTERON S. On alarm, the mobile app is notified instantly and remote action is possible when needed. Unusual temperature or humidity swings are reported too.'
    }
  }
];

export const SHALTERON_S_PRODUCT_FEATURES: Array<{ label: Localized<string>; value: Localized<string> }> = [
  { label: { tr: 'Ürün Adı', en: 'Product Name' }, value: { tr: 'SHALTERON S', en: 'SHALTERON S' } },
  {
    label: { tr: 'Entegre Sensör', en: 'Integrated Sensor' },
    value: { tr: 'Sıcaklık ve nem', en: 'Temperature and humidity' }
  },
  { label: { tr: 'Güç', en: 'Power' }, value: { tr: '12V DC / 1A', en: '12V DC / 1A' } },
  {
    label: { tr: 'Kontak Çıkışı', en: 'Contact Output' },
    value: { tr: '6 adet (10A 250V AC / 10A 30V DC)', en: '6 units (10A 250V AC / 10A 30V DC)' }
  },
  {
    label: { tr: 'Dijital Giriş', en: 'Digital Input' },
    value: { tr: '4 adet (Kuru kontaktır. Enerji verilmemelidir)', en: '4 units (Dry contact. Power should not be supplied)' }
  },
  { label: { tr: 'Dahili Buzzer', en: 'Internal Buzzer' }, value: { tr: 'Var', en: 'Yes' } },
  {
    label: { tr: 'Kutu Tipi', en: 'Box Type' },
    value: {
      tr: 'Ray tipi plastik kutu (Duvar montajı için kulakçıklar mevcuttur)',
      en: 'Rail type plastic box (Mounting ears available for wall mounting)'
    }
  },
  {
    label: { tr: 'Kutu Ölçüleri', en: 'Box Dimensions' },
    value: { tr: '160 x 105 x 60 mm', en: '160 x 105 x 60 mm' }
  },
  { label: { tr: 'Şebeke Desteği', en: 'Network Support' }, value: { tr: '4G Nano SIM', en: '4G Nano SIM' } }
];
